export default __webpack_public_path__ + "static/media/М.6697d943.png";